import { NgModule, Type, inject } from '@angular/core';
import { Routes, RouterModule, CanActivateFn } from '@angular/router';
import { AuthGuard } from './modules/account/services/guards/auth.guard';
import { SsoCallbackComponent } from './modules/account/components/sso-callback/sso-callback.component';

function mapToCanActivate(providers: Array<Type<{ canActivate: CanActivateFn }>>): CanActivateFn[] {
  return providers.map(provider => (...params) => inject(provider).canActivate(...params));
}

export const routes: Routes = [
  {
    path: 'account',
    loadChildren: () =>
      import('./modules/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'sso/login',
    component: SsoCallbackComponent
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: '',
    canActivate: mapToCanActivate([AuthGuard]),
    loadChildren: () =>
      import('./_stealth/layout/layout.module').then((m) => m.LayoutModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
